module.exports = __webpack_public_path__ + "static/media/turtle.627b4f70.jpg";